export function SectionCard({ title, children, onEdit, editing, extra }: {
  title: string; children: React.ReactNode;
  onEdit?: () => void; editing?: boolean; extra?: React.ReactNode;
}) {
  return (
    <div className="rounded-card bg-white p-4 shadow-card">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[8px] font-bold uppercase tracking-[0.32px] text-text-secondary">{title}</div>
        <div className="flex items-center gap-3">
          {extra}
          {onEdit && !editing && (
            <button onClick={onEdit} className="text-xs font-medium text-rausch hover:underline">Edit</button>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}
